export const PICTURE_HEIGHT = 153;
export const DEFAULT_OFFSET = PICTURE_HEIGHT / 2;
export const PICTURE_GUTTER = 12;
export const DOWN = 'down';
export const UP = 'up';



// WEBPACK FOOTER //
// ./app/containers/Premium/components/LiveSection/components/LiveCarousel/constants.js